import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import "@/assets/css/core.css";
import "@/assets/css/style.min.css";

createApp(App).use(router).mount("#app");
